import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogComponent } from '../dialog/dialog.component';
import * as lottieData from "../../../../assets/img/success_lottie_multi.json";
@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent {
  successJson: any = (lottieData as any).default;

  confirmButtonText = "Yes"
  cancelButtonText = "Cancel"
  isShowConfirmation: boolean = false;
  message: any;
  showPrompt: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<DialogComponent>) {

    if (data && data.message) {
      this.isShowConfirmation = false;
      this.showPrompt = true;
      
      this.message = data.message;
      if (data.buttonText) {
        this.confirmButtonText = data.buttonText.ok || this.confirmButtonText;
        this.cancelButtonText = data.buttonText.cancel || this.cancelButtonText;
      }
    }
    else if (data.cntx == 'confirmation') {
      
      this.isShowConfirmation = true;
      this.showPrompt = false;
    }
  }

  onConfirmClick(): void {
    this.isShowConfirmation = false;
    this.showPrompt = false;
    this.dialogRef.close(true);
  }
}
